import React, { FunctionComponent } from 'react';
import type { SpecialShowProps } from './types';
import { CompanyContent, OtherSpecial, RecruitmentContent as TypeRecruitmentContent, SpecialDetail } from '../../../types/specialShow';
import { SpecialContentCompany } from '../../organisms/specialContentCompany';
import { RecruitmentContent } from '../../organisms/recruitmentContent';
import { Loading } from '../../atoms/loading';

type Props = SpecialShowProps & {
  isPc: boolean;
  loading: boolean;
  specialDetail: SpecialDetail | null;
  otherSpecials: OtherSpecial[];
};

export const Presentation: FunctionComponent<Props> = ({
  isCompanyUser,
  noimage,
  hoverIcon,
  isPc,
  loading,
  specialDetail,
  otherSpecials,
}) => {
  return (
    <div className="l-articles js-background-fixed">
      <div className="l-articles-inner u-clear">
        <h1 className="articles-title">{specialDetail?.title}</h1>

        {specialDetail?.showDescription && (
          <nav className="articles-title-nav">
            <p>
              {specialDetail.showDescription.split("\n").map((t: string, i: number) => (
                <span key={i}>
                  {t}
                  <br />
                </span>
              ))}
            </p>
          </nav>
        )}

        <main className="l-articles-main">
          <div className="articles-list">
            {loading && <Loading />}
            <ul className="articles-list-inner">
              {specialDetail?.contents.map((c, index) => (
                specialDetail?.isCompanyContent ? (
                  <li key={c.id}>
                    <article className="article-card-container">
                      <div className="article-card-inner">
                          <SpecialContentCompany content={c as CompanyContent} hoverIcon={hoverIcon} />
                      </div>
                    </article>
                  </li>
                ) : (
                  <RecruitmentContent
                    key={c.id}
                    recruitment_id={c.id}
                    recruitmentNumber={index + 1}
                    page={1}
                    isStopped={(c as TypeRecruitmentContent).isStopped}
                    dataCategory='special'
                    dataValue={'recruitments' as any}
                    dataClickPoint={{
                      company: 'company',
                      image: 'image',
                      title: 'title'
                    }}
                    isBrandPage={false}
                    noimage={noimage}
                    isCompany={isCompanyUser}
                    isPc={isPc}
                    hoverIcon={hoverIcon}
                    sort={undefined}
                    isShowAttentionPeople={false}
                  />
                )
              ))}
            </ul>
          </div>
        </main>

        <aside className="l-articles-sub articles-subcontainer" id="js-l-articles-sub">
          <section className="article-filter">
            <div className="article-filter-heading">
              <h2 className="article-filter-heading-text">その他の特集</h2>

              <div className="article-filter-links">
                {otherSpecials?.map((osp) => (
                  <a
                    key={osp.id}
                    href={`/specials/${osp.id}`}
                    className="article-filter-links-item"
                  >
                    {osp.title}
                  </a>
                ))}
              </div>
            </div>
          </section>
        </aside>
      </div>
    </div>
  );
};
